import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EFollowupWorkflowInstanceStatus;
(function (EFollowupWorkflowInstanceStatus) {
  EFollowupWorkflowInstanceStatus["Active"] = "active";
  EFollowupWorkflowInstanceStatus["Expired"] = "expired";
  EFollowupWorkflowInstanceStatus["Completed"] = "completed";
  EFollowupWorkflowInstanceStatus["Errored"] = "errored";
})(EFollowupWorkflowInstanceStatus || (EFollowupWorkflowInstanceStatus = {}));
export let EFollowupWorkflowInstanceFollowupsStatus;
(function (EFollowupWorkflowInstanceFollowupsStatus) {
  EFollowupWorkflowInstanceFollowupsStatus["Pending"] = "pending";
  EFollowupWorkflowInstanceFollowupsStatus["True"] = "true";
  EFollowupWorkflowInstanceFollowupsStatus["False"] = "false";
  EFollowupWorkflowInstanceFollowupsStatus["Failure"] = "failure";
})(EFollowupWorkflowInstanceFollowupsStatus || (EFollowupWorkflowInstanceFollowupsStatus = {})); // based on Followup.FollowupModel
export const fieldsFollowupWorkflowInstance = _extends({}, fieldsIBaseModel, {
  context: {
    type: 'Object'
  },
  followups: {
    type: 'Object',
    array: true
  },
  followupWorkflow: {
    type: 'ID',
    ref: EModel.FollowupWorkflow
  },
  modelObject: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  status: {
    type: 'Option',
    values: EFollowupWorkflowInstanceStatus
  }
});